export default __webpack_public_path__ + "static/media/mastercard.959d4e33.svg";